$(".interline-slick").slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  draggable: true,
  dots: false,
  centerMode: false,
  arrows: true,
  infinite: true,
  accessibility: true,
  responsive: [
    {
      breakpoint: 860,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
  ],
});

$(".interline-video-container > iframe").each(function () {
  var oldSrc = $(this).attr("src");
  if (oldSrc.includes("youtu.be") || oldSrc.includes("watch")) {
    var newSrc = oldSrc.replace(
      /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11}).*/,
      "https://youtube.com/embed/$1"
    );
    $(this).attr("src", newSrc);
  }
});

$(document).ready(function ($) {
  function updateVariantDisplay() {
    var selectedVariantId = $(".variant-selection").attr("variant");
    $(".variant-specific-div").hide();
    $(`[id=variant-${selectedVariantId}]`).show();
  }

  updateVariantDisplay();

  $(".variant-selection").on("change", function () {
    updateVariantDisplay();
  });

  var variantDesc = $(".variant-specific-div.product-description.rte");
  var prodDesc = $(".product-description.rte");

  if (prodDesc) {
    variantDesc.hide();
  }
});

$(document).on('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function(options) {
    // Change the placeholder text of the autocomplete menu
    options.placeholder = "What are you looking for?";
    return options;
  });
});

// Adding "add to cart" button and checking stock status
$(document).ready(function () {
    function addCartButton() {
        $('.ais-hit').each(function () {
            var $hit = $(this);
            var variantId = $hit.data('variant-id');

            if (variantId) {
                // Fetch product data
                $.getJSON(`/products/${$hit.data('handle')}.js`, function (product) {
                    var variant = product.variants.find(v => v.id == variantId);

                    if (variant) {
                        var isInStock = variant.available;
                        var price = (variant.price / 100).toFixed(2); // Convert cents to dollars
                        var compareAtPrice = variant.compare_at_price ? (variant.compare_at_price / 100).toFixed(2) : null;

                        if ($hit.find('.add-to-cart-btn').length === 0) {
                            var stockText = isInStock ? "In Stock" : "Out of Stock";
                            var buttonState = isInStock ? '' : 'disabled';

                            var priceHTML = `<div class="prices"><span class="price">$${price}</span></div>`;
                            if (compareAtPrice && parseFloat(compareAtPrice) > parseFloat(price)) {
                                priceHTML = `
                                    <div class="prices">
                                    <span class="price discounted">$${price}</span>
                                    <span class="compare-at-price">$${compareAtPrice}</span>
                                    </div>
                                `;
                            }

                            $hit.find('.ais-hit--details').append(`
                                ${priceHTML}
                                <p class="stock-status ${isInStock ? 'in-stock' : 'out-of-stock'}">${stockText}</p>
                                <button class="product-form--atc-button add-to-cart-btn" type="button" data-variant-id="${variantId}" ${buttonState}>
                                    Add to cart
                                </button>
                            `);
                        } else {
                            $hit.find('.stock-status').text(stockText);
                            $hit.find('.add-to-cart-btn').prop('disabled', !isInStock);
                        }
                    }
                });
            }
        });
    }

    addCartButton();

    // Poll to handle dynamic loading
    var pollInterval = setInterval(function () {
        addCartButton();
    }, 500);

    setTimeout(function () {
        clearInterval(pollInterval);
    }, 60000);

    // Add to Cart functionality
    $(document).on('click', '.add-to-cart-btn', function (e) {
        e.stopPropagation();
        e.preventDefault();

        var variantId = $(this).data('variant-id');
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                id: variantId,
                quantity: 1
            },
            dataType: 'json',
            success: function () {
                updateCartCounter();
            }
        });
    });

    $(document).on('click', '.ais-facet-category', function () {
        setTimeout(addCartButton, 500);
    });

    // Update cart counter
    function updateCartCounter() {
        $.getJSON('/cart.js', function (cart) {
            var itemCount = cart.item_count;
            var $cartCount = $('.site-header-cart--count');

            if (itemCount > 0) {
                $cartCount.addClass('visible');
                $cartCount.attr('data-header-cart-count', itemCount);
            } else {
                $cartCount.removeClass('visible');
                $cartCount.attr('data-header-cart-count', '');
            }
        });
    }

    $(document).on('cart:updated', function () {
        updateCartCounter();
    });

    updateCartCounter();
});